<template>
  <div>
    <v-combobox
      :items="prescribersNames"
      :search-input.sync="instance.school"
      label="Nom du prescripteur (école pour alternant, cabinet RH….) "
      :error-messages="errors.collect('school')"
      v-validate="''"
      :hide-no-data="true"
      :return-masked-value="true"
      data-vv-name="school"
      v-if="project == null"
      hint="Ecoles, organismes RH, agences immobilières ..."
      class="hide-arrow"
    ></v-combobox>
    <div v-if="project != null && project.school">{{ project.school }}</div>
    <div v-if="project != null && !project.school">Pas de prescripteur</div>
  </div>
</template>

<script>
import { fetchHil2 } from "../../utils";

export default {
  name: "ProjectPrescriber",
  props: ["value", "project"],
  mounted() {
    if (this.project != null) {
      console.log(Object.keys(this.project));
      const { school, schoolMail, schoolPhone } = this.project;
      this.instance = {
        school,
        schoolPhone,
        schoolMail
      };
    }
    this.send();
    this.fetchPrescriberAutocomplete();
  },
  computed: {
    prescribersNames() {
      return this.prescriberAutocomplete.map(({ name }) => name);
    }
  },
  data() {
    return {
      instance: {
        school: "",
        schoolMail: "",
        schoolPhone: "",
        prescriberId: null
      },
      prescriberAutocomplete: []
    };
  },
  methods: {
    async fetchPrescriberAutocomplete() {
      this.prescriberAutocomplete = await fetchHil2(
        "get",
        "/prospects/_autocomplete?type=prescripteur"
      );
    },
    async send() {
      await this.$validator.validate();
      this.$emit("input", { ...this.instance });
    }
  },
  watch: {
    instance: {
      deep: true,
      async handler() {
        const cpn = this.instance.school;
        const [company] = this.prescriberAutocomplete.filter(
          ({ name }) => name.toLowerCase() === cpn.toLowerCase()
        );
        if (company != null) {
          this.instance.prescriberId = company.id;
        } else {
          this.instance.prescriberId = null;
        }
        this.send();
      }
    }
  }
};
</script>

<style scoped></style>
